import './Herramientas.css';

function Herramientas() {
  return (
    <section className="herramientas-section py-5">
      <div className="container animate-on-scroll">
        <h2 className="text-center fw-bold mb-4 text-primary">Nuestras Herramientas</h2>
        <p className="text-center text-muted mb-5">
          Estas son las tecnologías que usamos para hacer realidad tus proyectos.
        </p>

        <div className="tools-carousel">
          <div className="tools-track">

            {/* Primera vuelta */}
            {renderIcons()}
            {/* Segunda vuelta (duplicado) */}
            {renderIcons()}

          </div>
        </div>
      </div>
    </section>
  );
}

function renderIcons() {
  return (
    <>
      <div className="tool-item">
        <img src="/img/TEC/React-icon.svg.png" alt="React" />
        <p>React</p>
      </div>
      <div className="tool-item">
        <img src="/img/TEC/flutter.png" alt="Flutter" />
        <p>Flutter</p>
      </div>
      <div className="tool-item">
        <img src="/img/TEC/firebase_icon-logo_brandlogos.net_tcvck.png" alt="Firebase" />
        <p>Firebase</p>
      </div>
      <div className="tool-item">
        <img src="/img/TEC/Node.js_logo.svg.png" alt="Node.js" />
        <p>Node.js</p>
      </div>
      <div className="tool-item">
        <img src="/img/TEC/mysql_original_wordmark_logo_icon_146417.webp" alt="MySQL" />
        <p>MySQL</p>
      </div>
      <div className="tool-item">
        <img src="/img/TEC/PHP-logo.svg.png" alt="PHP" />
        <p>PHP</p>
      </div>
      <div className="tool-item">
        <img src="/img/TEC/HTML5_logo_and_wordmark.svg.png" alt="HTML5" />
        <p>HTML5</p>
      </div>
      <div className="tool-item">
        <img src="/img/TEC/CSS3_logo_and_wordmark.svg.png" alt="CSS3" />
        <p>CSS3</p>
      </div>
      <div className="tool-item">
        <img src="/img/TEC/javascript.png" alt="JavaScript" />
        <p>JavaScript</p>
      </div>
    </>
  );
}

export default Herramientas;
